import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        paddingTop: 3,
    },
    titleContainer: {
        justifyContent: 'center',
    },
    subtitle: {
        marginLeft: 0,
    },
});

export default styles;
